import { render, staticRenderFns } from "./RealizedGainLossForm.vue?vue&type=template&id=ce1a2604&scoped=true&"
import script from "./RealizedGainLossForm.vue?vue&type=script&lang=js&"
export * from "./RealizedGainLossForm.vue?vue&type=script&lang=js&"
import style0 from "./RealizedGainLossForm.vue?vue&type=style&index=0&id=ce1a2604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1a2604",
  null
  
)

component.options.__file = "RealizedGainLossForm.vue"
export default component.exports